import React, { useEffect, useRef, useState } from "react"
import { Asset } from "../../../../plugins/gatsby-plugin-atollon"
import StructuredText from "../custom-structured-text-renderer"
import { graphql } from "gatsby"
import { EdgeTop1 } from "../../icons"

const ThreeColumnItem = ({ items, theme, whiteBackground }) => {

  return (
    <>
      <section className={`three-column-item ${theme || ""}${whiteBackground ? ' white-bg' : ''}`}>
        {theme === "woods" &&
          <div className="three-column-item__edge">
            <EdgeTop1 color="#FFFDED" />
          </div>
        }
        <div className="three-column-item__inner">
          <div className="three-column-item__items">
            {
              items?.length > 0 && items.map((el, i) => (
                <div key={i} className="three-column-item__item" data-sal="slide-up" data-sal-duration="1000"
                     data-sal-easing="ease">
                  {el.image && <Asset asset={el.image} />}
                  {el.title && <h3>{el.title}</h3>}
                  {el.richContent && <StructuredText data={el.richContent} />}
                </div>
              ))
            }
          </div>
        </div>
      </section>
    </>
  )
}

export default ThreeColumnItem

export const query = graphql`
fragment ThreeColumnItemProps on DatoCmsThreeColumnItem {
  ... on DatoCmsThreeColumnItem {
    id
    items {
      title
      richContent {
        value
      }
      image {
        ...InternalAssetProps
      }
    }
    whiteBackground
  }
}
`